/**
 * Order of the cards on /docs/sso and of the previous/next links. Its own
 * module so the router and the hreflang list do not pull the guides' text
 * (ssoGuides.ts) into the main bundle.
 */
export const SSO_GUIDE_SLUGS = [
  "okta",
  "entra-id",
  "google-workspace",
  "adfs",
  "generic-saml",
  "scim",
  "security",
] as const;

export type SsoGuideSlug = (typeof SSO_GUIDE_SLUGS)[number];
